import { useFetcher } from "~/hooks/useFetcher";
import { artifactPreviewsPath, type ArtifactPreview } from "~/services/artifacts";

// Resolves a single artifact by name against the conversations-api
// `GET /{conversationId}/artifacts/previews` endpoint. Returns the first
// (and only) preview, narrowing the batch endpoint to single-name lookup.
//
// Cached by SWR keyed on the request URL — repeat references to the same
// artifact within a conversation reuse one in-flight request and never
// refetch on re-render.
export function useArtifactPreview(conversationId: string, name: string) {
  const url = artifactPreviewsPath(conversationId, [name]);
  const { data, error, isLoading } = useFetcher<ArtifactPreview[]>(url);
  const preview = data?.[0];
  // Backend returns an empty array when the name doesn't resolve — surface
  // this distinctly from a network error so the renderer can show "missing".
  const notFound = !isLoading && !error && data !== undefined && preview === undefined;
  return { preview, error, isLoading, notFound };
}
